// third party imports
import React, { useState, useEffect, useContext } from "react";

// internal rebet imports
import "./stylesWhiteList.css";
import { SIDER_TABS } from "../../utils/Constants";
import Layout from "../CommonComponents/Layout/Layout";

// component imports
import RebetLoader from "../CommonComponents/RebetLoader/RebetLoader";
import WhiteListRow from "./WhiteListRow/WhiteListRow";
import createPrivateAdminPanelInstance from "../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../api/ApiRoutes";
import AddNewEventPopup from "./AddNewIpPopup/AddNewIpPopup";
import AppContext from "../../context/AppContext";
import { Modal } from "antd";
import EditAdminPopup from "./EditAdminPopup/EditAdminPopup";
import UserDeletionModal from "./UserDeletionModal/UserDeletionModal";
// asset imports

const WhiteList = () => {
  // non-state variables
  const token = JSON.parse(localStorage.getItem("token"));
  const email = JSON.parse(localStorage.getItem("email"));

  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.IdToken
  );

  const { setActiveSidebarTab } = useContext(AppContext);

  // state variables
  const [isApiRunning, setIsApiRunning] = useState(false);
  const [codesToShowInTable, setCodesToShowInTable] = useState([]);
  const [isAddNewEventsPopupVisible, setIsAddNewEventsPopupVisible] =
    useState(false);
  const [expandedAdminId, setExpandedAdminId] = useState(null);
  const [selectedAdmin, setSelectedAdmin] = useState(null);
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [isAddNewIpModalOpen, setIsAddNewIpModalOpen] = useState(false);
  const [isEditAdminModalOpen, setIsEditAdminModalOpen] = useState(false);
  const [isUserDeletionModalOpen, setIsUserDeletionModalOpen] = useState(false);

  const handleEditAdminModalOk = () => {
    setIsEditAdminModalOpen(false);
  };

  const handleEditAdminModalCancel = () => {
    setIsEditAdminModalOpen(false);
  };

  const handleUserDeletionModalOk = () => {
    setIsUserDeletionModalOpen(false);
  };

  const handleUserDeletionModalCancel = () => {
    setIsUserDeletionModalOpen(false);
  };

  // use effects

  // api functions
  const getAdmins = async () => {
    setIsApiRunning(true);

    try {
      const response = await PrivateAdminPanelInstance?.post(
        API_ROUTES?.GET_ADMINS
      );

      const data = response?.data.data;

      console.log("data", data);

      const currentUser = data.find((admin) => admin.email === email);

      const isSuperAdmin = currentUser?.group_name === "super-admin-v2";

      const dataWithKeys = data.map((item, index) => ({
        ...item,
        key: item.admin_id,
      }));

      setIsSuperAdmin(isSuperAdmin);

      setCodesToShowInTable(dataWithKeys);
      setIsApiRunning(false);
    } catch (error) {
      console.log("error getting admins", error);
    } finally {
      setIsApiRunning(false);
    }
  };

  useEffect(() => {
    getAdmins();
  }, []);

  useEffect(() => {
    setActiveSidebarTab(SIDER_TABS.STAFF_MANAGEMENT, "Agent Dashboard");
  }, [setActiveSidebarTab]);

  // helper functions
  const handleExpandAdmin = (adminId) => {
    setExpandedAdminId(expandedAdminId === adminId ? null : adminId);
  };

  const handlePopupVisible = (adminId, adminName) => {
    setSelectedAdmin({
      admin_id: adminId,
      admin_name: adminName,
    });
    setIsAddNewIpModalOpen(true);
  };

  const handleAddNewIpModalOk = () => {
    setIsAddNewIpModalOpen(false);
  };

  const handleAddNewIpModalCancel = () => {
    setIsAddNewIpModalOpen(false);
  };

  const updateAgentToggleStatus = async (adminId, groupName) => {
    const newData = codesToShowInTable.map((item) => {
      if (item.admin_id === adminId) {
        item.group_name = groupName;
      }
      return item;
    });
    setCodesToShowInTable(newData);
  };

  return (
    <Layout name={SIDER_TABS.STAFF_MANAGEMENT}>
      <div className="whitelist-body-container">
        <Modal
          closable={false}
          open={isAddNewIpModalOpen}
          onOk={handleAddNewIpModalOk}
          onCancel={handleAddNewIpModalCancel}
          footer={null}
          width={500}
        >
          <AddNewEventPopup
            onClosePressed={handleAddNewIpModalCancel}
            getAdmins={getAdmins}
            selectedAdmin={selectedAdmin}
          />
        </Modal>

        <div className="whitelist-table">
          <>
            <div className="head-controls">
              <div className="header-text-container">
                <p className="header-text">PAM Agent Dashboard</p>
              </div>
            </div>

            <div style={{ width: "100%" }}>
              {isApiRunning ? (
                <RebetLoader height={"100px"} width={"100px"} />
              ) : (
                <WhiteListRow
                  data={codesToShowInTable}
                  setData={setCodesToShowInTable}
                  agentSuperAdmin={isSuperAdmin}
                  handlePopupVisible={handlePopupVisible}
                  updateAgentToggleStatus={updateAgentToggleStatus}
                />
              )}
            </div>
          </>
        </div>
      </div>
    </Layout>
  );
};

export default WhiteList;
